import Vue from 'vue';
import { PeeringOperationConstant, SameTenant, SameRegion} from '@/common/Constants';

/**
 * 内容默认居中显示，改为靠左显示
 * @return {{style: string}}
 */
const getClass = () => ({ style: 'text-align: left; word-break: break-all' });

export default function operations(caseOps, target, row, type) {
	const h = target.$createElement;
	switch (parseInt(caseOps, 10)) {
		// 接受
		case PeeringOperationConstant.ACCEPT: {
			target.$msgbox({
				title: target.$t("peering.speechCraft.acceptTitle"),
				message: h('p', getClass(), [
					h('span', null, target.$t("peering.speechCraft.sureAccept", [row.name])),
				]),
				closeOnClickModal: false,
				showCancelButton: true,
				confirmButtonText: target.$t('popHelper.text.sure'),
				cancelButtonText: target.$t('popHelper.text.cancel'),
			}).then(() => {
				let param = {
					peerConnId: row.peerIden,
					region: target.region,
					clientToken: Normal.getClientToken()
				};
				Ajax.post('/api/cps/peerConn/modifyPeerConnAccept', param)
				.then((res) => {
					if (res.data && res.data.success) {
						target.$message.success(target.$t('privateNetInstance.operateSuccess'));
						target.refresh();
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						target.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				});
			}).catch(() => {

			});
			break;
		}
		// 拒绝
		case PeeringOperationConstant.REJECT: {
			let param = {
				peerConnId: row.peerIden,
				region: target.region,
				clientToken: Normal.getClientToken()
			};
			target.$msgbox({
				title: target.$t("peering.speechCraft.rejectTitle"),
				message: h('p', getClass(), [
					h('span', null, target.$t("peering.speechCraft.sureReject", [row.name])),
				]),
				closeOnClickModal: false,
				showCancelButton: true,
				confirmButtonText: target.$t('popHelper.text.sure'),
				cancelButtonText: target.$t('popHelper.text.cancel'),
			}).then(() => {
				Ajax.post('/api/cps/peerConn/modifyPeerConnReject', param)
				.then((res) => {
					let isSuccess = res.data && res.data.success;
					if (isSuccess) {
						target.$message.success(target.$t('privateNetInstance.operateSuccess'));
						target.refresh();
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						target.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				});
			}).catch(() => {

			});
			break;
		}
		// 删除
		case PeeringOperationConstant.DELETE: {
			const isSameRegion = SameRegion[row.isSameRegion];
			const isSameTenant = SameTenant[row.isSameTenant];
			let speechCraft;
			// 同地域
			if (isSameRegion) {
				speechCraft = target.$t('peering.speechCraft.sureDelete.isSameRegion', [row.name])
			} else {
				// 跨地域同账号
				if (isSameTenant) {
					speechCraft = target.$t('peering.speechCraft.sureDelete.isDiffRegionSameTenant', [row.name])
				} else { // 跨地域不同账号
					speechCraft = target.$t('peering.speechCraft.sureDelete.isDiffRegionDiffTenant', [row.name])
				}
			}
			target.$msgbox({
				title: target.$t("peering.speechCraft.deleteTitle"),
				message: h('p', getClass(), [
					h('span', null, speechCraft),
				]),
				closeOnClickModal: false,
				showCancelButton: true,
				confirmButtonText: target.$t('popHelper.text.sure'),
				cancelButtonText: target.$t('popHelper.text.cancel'),
			}).then(() => {
				let param = {
					peerConnId: row.peerIden,
					region: target.region,
					clientToken: Normal.getClientToken()
				};
				Ajax.del('/api/cps/peerConn/delete', param)
				.then((res) => {
					let pageType = type;
					let isSuccess = res.data && res.data.success;
					if (isSuccess) {
						target.$message.success(target.$t('privateNetInstance.operateSuccess'));
						if (pageType === 'detail') {
							target.$router.push({
								name: 'PeeringList',
								params: { region: target.region }
							});
						} else if (pageType === 'list') {
							target.refresh();
						}
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						target.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				});
			}).catch(() => {

			});
			break;
		}
		default:
		break;
	}
};




// WEBPACK FOOTER //
// ./src/common/PeeringPopHelper.js